/* eslint-disable */
function onChange(master, slave, value) {
  const $slaveInput = $(slave).find('input, textarea, select');
  switch (value) {
    case 'false':
    case 'undefined':
    case '': {
      slave.removeAttribute('data-required');
      slave.setAttribute('data-disabled', true);
      $slaveInput.attr('disabled', true);
      break;
    }
    default: {
      slave.removeAttribute('data-disabled');
      slave.setAttribute('data-required', true);
      $slaveInput.attr('disabled', false);
      break;
    }
  }
}

export default function (master, slave) {
  onChange(master, slave, master.value);
  $(master).on('change input', function () {
    onChange(master, slave, this.value);
  });
}



// WEBPACK FOOTER //
// ./scripts/blocks/form/connect-inputs.js